/** 경과·소요 시간 표기 — 초를 `1h 2m 3s` / `2m 3s` / `3s` 로. 제어 바의 경과와 결과 목록의 소요가 같은 표기를 쓴다. */
export function formatElapsed(seconds: number): string {
  const total = Math.max(0, Math.floor(seconds));
  const h = Math.floor(total / 3600);
  const m = Math.floor((total % 3600) / 60);
  const s = total % 60;
  if (h > 0) return `${h}h ${m}m ${s}s`;
  if (m > 0) return `${m}m ${s}s`;
  return `${s}s`;
}
